import { render, staticRenderFns } from "./ProductHero.vue?vue&type=template&id=8a2e035c&scoped=true&"
import script from "./ProductHero.vue?vue&type=script&lang=js&"
export * from "./ProductHero.vue?vue&type=script&lang=js&"
import style0 from "./ProductHero.vue?vue&type=style&index=0&id=8a2e035c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e035c",
  null
  
)

export default component.exports